import React from "react";
import "./Experience.css";

import NIlogo from "../images/national-instruments-logo.png";

function Experience() {
  const experiences = [
    {
      id: 1,
      role: "Software Engineer 1",
      company: "National Instruments",
      techstack: ["C#", ".NET", "WPF", "LabVIEW"],
      timeframe: "July 2026 - Present",
      location: "Bengaluru, India",
      logo: NIlogo,
      website: "https://www.ni.com/",
    },
    {
      id: 2,
      role: "SDE Intern",
      company: "National Instruments",
      techstack: ["C#", ".NET", "WPF", "LabVIEW"],
      timeframe: "July 2025 - June 2026",
      location: "Bengaluru, India",
      logo: NIlogo,
      website: "https://www.ni.com/",
    },
  ];

  return (
    <section className="experience-section">
      <div className="experience-container">
        <h1>Experience</h1>
        <div className="experience-list">
          {experiences.map((exp) => (
            <article className="experience-card" key={exp.id}>
              <div className="experience-header">
                <div className="experience-logo">
                  {exp.logo ? (
                    <img src={exp.logo} alt={`${exp.company} logo`} />
                  ) : (
                    <div className="logo-placeholder">{exp.company[0]}</div>
                  )}
                </div>
                
                <div className="experience-title-section">
                  <div className="experience-title">
                    <h3>{exp.role}</h3>
                    <a 
                      href={exp.website} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="company-name"
                    >
                      {exp.company}
                    </a>
                  </div>
                  <div className="tech-stack">
                    {exp.techstack.map((tech, index) => (
                      <span key={index}>{tech} {"\u00A0"}{index < exp.techstack.length - 1 ? " • " : ""}{"\u00A0"}</span>
                    ))}
                  </div>

                  <div className="experience-meta">
                    <span className="time">{exp.timeframe}</span>
                    <span className="dot">•</span>
                    <span className="location">{exp.location}</span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;